var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'CakeHome' }}},[_c('img',{attrs:{"src":require("@/assets/cake/cake.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }